<script lang="ts">
export default {
    name: 'BaseBreadcrumbs',
};
</script>

<script setup lang="ts">
import { computed, provide } from 'vue';
import { BaseBreadcrumbs } from '@/components/base-components/components/breadcrumbs/context';

const props = withDefaults(defineProps<{
    divider?: string | object;
}>(), {
    divider: '/',
});

const divider = computed(() => props.divider);

provide(BaseBreadcrumbs, {
    divider,
});
</script>

<template>
    <div class="inline-flex items-center truncate">
        <slot />
    </div>
</template>
